import { PdfElementPreview } from '../common/PdfElementPreview';

export function SecondaryResumePreviewComponent() {
  return <PdfElementPreview title="Segnaposto di Riepilogo Secondario" />;
}
